import React from "react";
import styles from "./Footer.module.css";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p className={styles.copyright}>
        © {new Date().getFullYear()} LawyersCo. Todos los derechos reservados.
      </p>
      <p className={styles.developedBy}>
        Desarrollado por{" "}
        <a
          href="https://softweare.com.ar"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          SOFTWEARE
        </a>
      </p>
    </footer>
  );
};